(() => {
  const nav = document.querySelector('.cs-nav');
  if (!nav || nav.dataset.ready) return;
  nav.dataset.ready = 'true';
  const menu = nav.querySelector('details');
  nav.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    if (menu) menu.open = false;
    if (!link.hash || link.pathname !== location.pathname) return;
    const target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    event.preventDefault();
    if (menu) menu.open = false;
    target.scrollIntoView({ behavior: 'instant', block: 'start' });
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && menu?.open) {
      menu.open = false;
      menu.querySelector('summary').focus();
    }
  });
  document.addEventListener('click', event => {
    if (menu?.open && !nav.contains(event.target)) menu.open = false;
  });
})();

(() => {
  const initialise = root => {
    root.querySelectorAll('[data-cs-gallery]').forEach(gallery => {
      if (gallery.dataset.initialised) return;
      gallery.dataset.initialised = 'true';
      const track = gallery.querySelector('[data-cs-gallery-track]');
      const slides = Array.from(gallery.querySelectorAll('[data-cs-gallery-slide]'));
      const controls = Array.from(gallery.querySelectorAll('[data-cs-colour]'));
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const select = index => {
        const slide = slides[index];
        if (!slide) return;
        const delta = slide.getBoundingClientRect().left - track.getBoundingClientRect().left;
        track.scrollBy({left: delta, behavior: reduced.matches ? 'instant' : 'smooth'});
      };
      controls.forEach((button, index) => button.addEventListener('click', () => select(index)));
      const sync = () => {
        const left = track.getBoundingClientRect().left;
        let selected = 0;
        slides.forEach((slide, index) => {
          if (Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(slides[selected].getBoundingClientRect().left - left)) selected = index;
        });
        controls.forEach((button, index) => button.setAttribute('aria-pressed', String(index === selected)));
      };
      let frame;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(sync);
      }, {passive: true});
      track.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        const selected = controls.findIndex(button => button.getAttribute('aria-pressed') === 'true');
        select(Math.max(0, Math.min(slides.length - 1, selected + (event.key === 'ArrowRight' ? 1 : -1))));
      });
      sync();
    });
  };
  initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();

if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){subscribe(PUB_SUB_EVENTS.cartUpdate,()=>{fetch(window.routes.cart_url+'.js',{headers:{Accept:'application/json'}}).then(r=>r.json()).then(cart=>document.querySelectorAll('[data-cs-bag-count]').forEach(e=>e.textContent=cart.item_count)).catch(()=>{});});}
